import { vendorFacilityAdapter } from './reducer'

export const {
  selectAll: selectAllVendorFacilities,
  selectById: selectVendorFacilityById,
} = vendorFacilityAdapter.getSelectors(state => state.vendorFacilities)
